import { motion } from "framer-motion";
import { Check, Minus, MessageCircle, Mail } from "lucide-react";
import { TRIP, INCLUDES, NOT_INCLUDES, IMAGES, CONTACT, whatsappUrl, mailtoUrl } from "../../data";
import { fadeUp, viewportOnce } from "../../lib/motion";

export const Pricing = () => (
  <section id="precio" data-testid="pricing" className="relative bg-ink py-24 sm:py-32 lg:py-40 overflow-hidden">
    <div className="absolute inset-0 opacity-[0.14]">
      <img src={IMAGES.glacier} alt="" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-ink/60" />
    </div>

    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Left: dates + price */}
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="lg:col-span-6">
          <div className="overline mb-6">Precio & fechas</div>
          <div className="inline-flex items-center gap-3 border border-white/15 px-4 py-2 mb-8">
            <span className="h-2 w-2 rounded-full bg-glacier animate-pulse" style={{ backgroundColor: "var(--glacier)" }} />
            <span className="font-body text-xs uppercase tracking-[0.2em] text-[var(--muted)]">{TRIP.soldout}</span>
          </div>

          <h2 className="font-display font-light text-5xl sm:text-7xl leading-[0.9] tracking-tight">{TRIP.dates}</h2>
          <p className="mt-4 font-body text-[var(--muted)]">
            {TRIP.duration} · {TRIP.departure} · {TRIP.seats}
          </p>

          <div className="mt-12 flex items-end gap-3">
            <span className="font-display font-light text-7xl sm:text-8xl leading-none">{TRIP.price}</span>
            <span className="font-display text-4xl text-glacier mb-2">{TRIP.currency}</span>
          </div>
          <p className="mt-3 font-body text-sm text-[var(--muted)]">{TRIP.priceNote}</p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="pricing-whatsapp"
              className="group inline-flex items-center justify-center gap-3 bg-glacier text-ink px-8 py-5 font-body font-bold uppercase tracking-[0.15em] text-xs shadow-[0_0_40px_rgba(244,100,42,0.3)] hover:shadow-[0_0_60px_rgba(244,100,42,0.5)] transition-shadow duration-500"
              style={{ backgroundColor: "var(--glacier)", color: "var(--ink)" }}
            >
              <MessageCircle className="h-4 w-4" />
              Reserva por WhatsApp
            </a>
            <a
              href={mailtoUrl()}
              data-testid="pricing-email"
              className="btn-glacier inline-flex items-center justify-center gap-3 border border-white/25 px-8 py-5 font-body font-semibold uppercase tracking-[0.15em] text-xs text-[var(--paper)] hover:text-ink transition-colors duration-300"
            >
              <Mail className="h-4 w-4" />
              Escríbenos
            </a>
          </div>
          <p className="mt-5 font-body text-xs text-[var(--muted)]">
            {CONTACT.whatsappDisplay} · {CONTACT.email}
          </p>
        </motion.div>

        {/* Right: includes */}
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="lg:col-span-6 lg:pl-8 lg:border-l border-white/10">
          <h3 className="font-display italic text-2xl sm:text-3xl mb-8 text-[var(--paper)]/90">Incluye</h3>
          <ul className="grid grid-cols-1 gap-x-8 gap-y-4">
            {INCLUDES.map((inc, i) => (
              <li key={i} data-testid={`include-${i}`} className="flex items-start gap-3">
                <Check className="h-4 w-4 mt-1 shrink-0 text-glacier" strokeWidth={2} />
                <span className="font-body font-light text-sm text-[var(--paper)]/80 leading-relaxed">{inc}</span>
              </li>
            ))}
          </ul>

          <h3 className="font-display italic text-2xl sm:text-3xl mt-12 mb-6 text-[var(--paper)]/90" style={{ color: "var(--ember)" }}>No incluye</h3>
          <ul className="grid grid-cols-1 gap-y-4">
            {NOT_INCLUDES.map((inc, i) => (
              <li key={i} data-testid={`not-include-${i}`} className="flex items-start gap-3">
                <Minus className="h-4 w-4 mt-1 shrink-0" style={{ color: "var(--ember)" }} strokeWidth={2} />
                <span className="font-body font-light text-sm text-[var(--muted)] leading-relaxed">{inc}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </section>
);
